import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import AuthShell, { Field } from "./AuthShell";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name || "there"}!`);
      navigate(u.role === "worker" ? "/app" : "/admin", { replace: true });
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Sign in to GTForce" subtitle="Access your workforce command center."
      footer={<>New to GTForce? <Link to="/register" className="text-[#1D4ED8] font-semibold">Create an account</Link></>}>
      <form onSubmit={submit} className="space-y-4">
        <Field label="Email" data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" />
        <Field label="Password" data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
        <div className="text-right">
          <Link to="/forgot-password" data-testid="login-forgot-link" className="text-sm text-slate-500 hover:text-[#1D4ED8]">Forgot password?</Link>
        </div>
        <button data-testid="login-submit" disabled={loading} className="w-full py-3 rounded-full bg-[#1D4ED8] text-white font-semibold hover:bg-[#1E40AF] transition-colors disabled:opacity-60">
          {loading ? "Signing in…" : "Sign In"}
        </button>
      </form>
    </AuthShell>
  );
}
